import React from "react";

import moment from "moment";

import { withRouter } from "react-router-dom";

import LocationFormat from "../../../utils/LocationFormat";
import Currency from "../../../utils/Currency";
import General from "../../../utils/General";
import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";

import FetchHelper from "../../../utils/FetchHelper";

import BaseTable from "./BaseTable";

const STATUS_FILTERS = {
  name: {
    api: "statuses",
    display: "Status",
  },
  values: [
    {
      label: "All",
      value: null,
    },
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Accepted",
      value: "accepted",
    },
    {
      label: "Looking for Driver",
      value: "looking_for_driver",
    },
    {
      label: "Rejected",
      value: "rejected",
    },
  ],
};

const DELIVERY_STATUS_FILTERS = {
  name: {
    api: "delivery_statuses",
    display: "Delivery Status",
  },
  values: [
    {
      label: "All",
      value: null,
    },
    {
      label: "Pending",
      value: "pending",
    },
    {
      label: "Out For Delivery",
      value: "out_for_delivery",
    },
    {
      label: "Failed",
      value: "failed",
    },
    {
      label: "Returned",
      value: "returned",
    },
    {
      label: "Delivered",
      value: "delivered",
    },
  ],
};

class OverviewTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isLoading: false,
        nextProps: {},
        drivers: [],
        nextDriversUrl: null,
        isLoadingDrivers: false,
      };
    this.table = React.createRef();
    // this._getDrivers();
  }

  componentDidMount() {
  this._getDrivers();
}

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _renderAddress(address) {
    return <span>{address ? LocationFormat.fullAddress(address) : "-"}</span>;
  }



 _getDrivers = async (url = null) => {
  if (this.state.isLoadingDrivers) return;

  this.setState({ isLoadingDrivers: true });

  try {
    let requestUrl = url;

    if (!requestUrl) {
      const separator = window.Api.Drivers.includes("?") ? "&" : "?";

      requestUrl =
        `${window.Api.Drivers}${separator}` +
        "page=1&page_size=20&pagination_type=page";
    }

    const data = await FetchHelper.get(requestUrl, false);
    // const newDrivers = Array.isArray(data) ? data : data?.results || [];
    const results = Array.isArray(data) ? data : data?.results || [];

    console.log("Fetched drivers:", results);

    const newDrivers = results.filter(
      (driver) =>
        String(driver?.application_status || "")
          .trim()
          .toLowerCase() === "approved"
    );

    this.setState((previousState) => {
      const driversById = new Map();

      [...previousState.drivers, ...newDrivers].forEach((driver) => {
        const driverId = driver?.user?.id;

        if (driverId != null) {
          driversById.set(String(driverId), driver);
        }
      });

      return {
        drivers: Array.from(driversById.values()),
        nextDriversUrl: data?.next || null,
        isLoadingDrivers: false,
      };
    });
  } catch (error) {
    Notify.error(error.message || "Failed to load drivers");
    this.setState({ isLoadingDrivers: false });
  }
};

_getPageNumber = (nextUrl) => {
  if (!nextUrl) return null;

  try {
    const url = new URL(nextUrl, window.location.origin);
    return url.searchParams.get("page");
  } catch (error) {
    return null;
  }
};

  _acceptOrder(event, orderId) {
    const driverId = event.target.value;
    let data = {
      driver: driverId,
      status: 'accepted',
    };
    this.setState({ isLoading: true });
    Backend.updateDeliveryRequest(orderId, data)
      .then(res => {
        console.log(res);
        this.setState({ res, isLoading: false });
        window.location.reload();
      })
      .catch(err => {
        Notify.error(err.message);
        console.log('Oops!', err.message);
        this.setState({ isLoading: false });
      });
  }

  _completeOrder(orderId) {
    this.setState({ isLoading: true });
    Backend.completeOrder(orderId)
      .then((data) => {
        this.setState({ data, isLoading: false });
        window.location.reload();
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _getColumns() {
    return [
      {
        Header: () => <strong className="header__clr">ORDER NO.</strong>,
        id: "id",
        width: 95,
        Cell: (rowInfo) => {
          let order = rowInfo.original;
          let orderNumber = `${order.id}`;

          if (!orderNumber) {
            return "-";
          }

          return (
            <>
              <span className="text-dark-75 font-weight-bold line-height-sm">
                {orderNumber}
              </span>
            </>
          );
        },
      },
    
{
  Header: () => <strong className="header__clr">DETAILS</strong>,
  id: "address",
  width: 140,
  sortable: false,
  Cell: (rowInfo) => {
    let order = rowInfo.original;

    // Fix 1: Safe access to vendor title
    let vendor = General.toTitleCase(order?.venue?.company?.title || "Unknown Vendor");

    // Fix 2: Safe access to customer_address
    let address = order?.data?.customer_address;

    if (!address) {
      return <span>-</span>;
    }

    const handleClick = () => {
      // Fix 3: Safe access within the click handler
      const addrData = rowInfo?.original?.data?.customer_address;
      if (addrData?.latitude && addrData?.longitude) {
        const coords = `${addrData.latitude},${addrData.longitude}`;
        const googleMapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(coords)}`;
        window.open(googleMapsUrl, "_blank");
      }  
    };

    return (
      <div className="ml-0 overflow-hidden" onClick={handleClick} style={{ cursor: 'pointer'}}>
        <div className="text-dark-75 font-weight-bold line-height-sm">
          {vendor}
        </div>
        <div className="font-size-sm text-dark-50">
          {this._renderAddress(address)}
        </div>
      </div>
    );
  },
},
      {
        Header: () => <strong className="header__clr">STATUS</strong>,
        id: "status",
        width: 90,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let labelClass = "";
          let status = "";

          if (order.status === "accepted") {
            labelClass = "label-light-success";
            status = "Accepted";
          } else if (order.status === "pending") {
            labelClass = "label-dark-75";
            status = "Pending";
          } else if (order.status === "looking_for_driver") {
            labelClass = "label-light-info";
            status = "Looking For Driver";
          } else if (order.status === "rejected") {
            labelClass = "label-danger";
            status = "Rejected";
          }

          if (!status) {
            return "-";
          }

          return (
            <span className={`label ${labelClass} label-inline label-pill`}>
              {status}
            </span>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">DELIVERY</strong>,
        id: "delivery_status",
        width: 90,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let labelClass = "";
          let deliveryStatus = "";

          if (order.delivery_status === "delivered") {
            labelClass = "label-light-success";
            deliveryStatus = "Delivered";
          } else if (order.delivery_status === "pending") {
            labelClass = "label-light-info";
            deliveryStatus = "Pending";
          } else if (order.delivery_status === "failed") {
            labelClass = "label-dark-75";
            deliveryStatus = "Failed";
          } else if (order.delivery_status === "returned") {
            labelClass = "label-danger";
            deliveryStatus = "Returned";
          } else if (order.delivery_status === "out_for_delivery") {
            labelClass = "label-warning";
            deliveryStatus = "Out For Delivery";
          }

          if (!deliveryStatus) {
            return "-";
          }

          return (
            <>
              <span className={`label ${labelClass} label-inline label-pill`}>
                {deliveryStatus}
              </span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">DRIVER</strong>,
        id: "user__first_name",
        width: 140,
        sortable: false,

    Cell: (rowInfo) => {
      const order = rowInfo.original;
      const {
        drivers,
        nextDriversUrl,
        isLoadingDrivers,
      } = this.state;

      if (order?.driver?.user) {
        const user = order.driver.user;

        return (
          <div className="overflow-hidden">
            {`${General.toTitleCase(
              user.first_name
            )} ${General.toTitleCase(user.last_name)}`}
          </div>
        );
      }

      if (order.status === "rejected") {
        return <div className="overflow-hidden">-</div>;
      }

      const handleChange = (event) => {
        const selectedValue = event.target.value;

        if (selectedValue === "__load_more__") {
          this._getDrivers(nextDriversUrl);
          return;
        }

        if (selectedValue) {
          this._acceptOrder(event, order.id);
        }
      };

  return (
    <div className="overflow-hidden">
      <select
        className="form-control"
        value=""
        onChange={handleChange}
        disabled={isLoadingDrivers && drivers.length === 0}
      >
        <option value="">
          {isLoadingDrivers && drivers.length === 0
            ? "Loading drivers..."
            : "Select Driver"}
        </option>

        {drivers.map((driver) => {
          const user = driver?.user;

          if (!user?.id) return null;

          return (
            <option key={user.id} value={user.id}>
              {`${General.toTitleCase(
                user.first_name
              )} ${General.toTitleCase(user.last_name)}`}
            </option>
          );
        })}

        {nextDriversUrl && (
          <option value="__load_more__">
            {isLoadingDrivers
              ? "Loading more drivers..."
              : "Load more drivers..."}
          </option>
        )}
      </select>
    </div>
  );
},




      },
      // Locate the "DRIVER FEE" column in _getColumns()
{
  Header: () => <strong className="header__clr">DRIVER FEE</strong>,
  id: "id", // Suggestion: change this to a unique string like 'driver_fee'
  width: 100,
  sortable: false,
  Cell: (rowInfo) => {
    let order = rowInfo.original;
    // console.log("Order payment details:", order); // Debugging line
    // Use optional chaining (?.) for BOTH properties and provide 0 as a fallback
    let deliveryFee = order.payment?.delivery_driver_fee || 0;
    let tip = order.payment?.tip || 0;
    
    let driverFee = deliveryFee + tip;

    if (driverFee === 0) {
      return "-";
    }

    return (
      <>
        <span>{Currency.format(driverFee)}</span>
      </>
    );
  },
},



      {
        Header: () => <strong className="header__clr">SERVICE FEE</strong>,
        id: "id",
        width: 100,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let serviceFee = order.payment?.service_fee;

          if (!serviceFee) {
            return "-";
          }

          return (
            <>
              <span>{Currency.format(serviceFee)}</span>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">TOTAL</strong>,
        id: "price",
        width: 90,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let cost = order?.payment?.total;

          if (!cost) {
            return "-";
          }

          return (
            <>
              <span>{Currency.format(cost)}</span>
            </>
          );
        },
      },
      {
        Header: () => (
          <strong className="header__clr">ORDER DATE / TIME</strong>
        ),
        id: "created_at",
        width: 140,
        Cell: (rowInfo) => {
          let order = rowInfo.original;
          let createdAt = `${moment(order.created_at).format(
            "DD MMM YYYY - hh:mm A"
          )}`;

          if (!order?.created_at) {
            return "-";
          }

          return (
            <>
              <div className="text-dark-75 font-weight-bold line-height-sm overflow-hidden">
                {createdAt}
              </div>
            </>
          );
        },
      },
      {
        Header: () => <strong className="header__clr">ACTIONS</strong>,
        id: "id",
        width: 90,
        sortable: false,
        Cell: (rowInfo) => {
          let order = rowInfo.original;

          let contactEmail = order?.venue?.contact_email;

          return (
            <>
              <span style={{ width: 130 }}>
                <a
                  href={`mailto: ${contactEmail}`}
                  target="_blank"
                  className="btn btn-icon btn-sm btn-pill btn-outline-primary ml-3"
                  data-toggle="popover"
                  data-content="Contact Vendor"
                >
                  <span className="svg-icon svg-icon-md">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect x={0} y={0} width={24} height={24} />{" "}
                        <path
                          d="M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                          fill="#FF5E8A"
                        />
                      </g>
                    </svg>
                  </span>
                </a>
                <a
                  href="javascript:;"
                  className="btn btn-icon btn-sm btn-pill btn-outline-primary ml-3"
                  data-toggle="popover"
                  data-content="Complete Order"
                  title="Complete Order"
                  onClick={() => this._completeOrder(order?.id)}
                >
                  <span className="svg-icon svg-icon-md">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                      >
                        <path fill="#73113b" d="M12 22.588c-5.839 0-10.588-4.75-10.588-10.588C1.412 6.161 6.161 1.412 12 1.412c5.839 0 10.588 4.75 10.588 10.588 0 5.839-4.75 10.588-10.588 10.588M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0M10.679 14.474 7.288 11.084l-1.025 1.025 4.389 4.389 6.503-6.503-1.025-1.025-6.451 6.504Z" />
                      </g>
                    </svg>
                  </span>
                </a>
              </span>
            </>
          );
        },
      },
    ];
  }

  render() {
    const { isLoading } = this.state;

    const columns = this._getColumns();

    const ordersSeparator = window.Api.Orders.includes("?")
      ? "&"
      : "?";

      console.log("Orders API URL:", ordersSeparator); // Debugging line

    const ordersEndpoint =
      `${window.Api.Orders}${ordersSeparator}` +
      "page_size=20" +
      "&pagination_type=page" +
      "&ordering=-created_at";


    console.log("Orders endpoint:", ordersEndpoint); // Debugging line

    let tableProps = {};

    return (
      <>


<BaseTable
  {...tableProps}
  ref={this.table}
  title={this.props.title}
  loading={isLoading}
  endpoint={ordersEndpoint}
  noDataMessage="No orders found"
  columns={columns}
  filters={[STATUS_FILTERS, DELIVERY_STATUS_FILTERS]}
  defaultSorted={[
  { id: "created_at", desc: true }
  ]}
  showPagination={true}
  getTrProps={(state, rowInfo) => {
    const order = rowInfo?.original;
    const status = String(order?.status || "").trim();
    const address = order?.data?.customer_address;

    const vendorTitle = String(
      order?.venue?.company?.title || ""
    ).trim();

    const hasAddress =
      address &&
      typeof address === "object" &&
      Object.keys(address).length > 0;

    const shouldHide =
      !status ||
      status === "-" ||
      !hasAddress ||
      !vendorTitle;

    return {
      style: {
        display: shouldHide ? "none" : undefined,
      },
    };
  }}
/>

      </>
    );
  }
}

OverviewTable.defaultProps = {
  title: "Latest Orders",
  showPagination: true,
  showPaginationTop: true,
  showPaginationBottom: true,
};

export default withRouter(OverviewTable);
